import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8 md:p-12 text-center">
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-blue-50 flex items-center justify-center">
          <Icon name="Search" size={40} color="var(--color-primary)" />
        </div>
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-3">
        Aucune filière trouvée
      </h3>
      <p className="text-sm md:text-base text-gray-600 mb-6 max-w-md mx-auto">
        Aucune filière ne correspond aux filtres sélectionnés. Essayez de modifier vos critères de recherche ou réinitialisez les filtres.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="default"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={() => window.location?.reload()}
        >
          Réinitialiser les filtres
        </Button>
        <Button
          variant="outline"
          iconName="MessageSquare"
          iconPosition="left"
          onClick={() => navigate('/ai-chat-interface')}
        >
          Consulter l'IA
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;